import React, {useState, useEffect, useContext, useMemo} from "react";
import { motion } from 'framer-motion';
import ReactPlayer from "react-player";
import { useNavigate, useParams } from 'react-router-dom';
import { AppContext } from './ContextVars';
import translations from './translations';
import ScrollToSection from "./ScrollToSection";
import { productize, localizePlan, tidyPlanHtml } from "./planHelpers"; // #added i18n + limpieza de HTML 24/9/26 TG
import { metaEvent, metaProduct } from "./metaPixel"; // #added 2/11/26 TG


const Program = () => {

    const [activeSection, setActiveSection] = useState(0); // #added 2/5/25 TG #mod default = Todos (0) 10/10/26 TG
    const navigate = useNavigate();
    const { planId } = useParams(); // #deep link por ID de programa en la URL (ej: /program/3) #added 31/7/26 TG
  const { totalAmount, setTotalAmount } = useContext(AppContext);
  const {totalAmountGTQ, setTotalAmountGTQ} = useContext(AppContext);
  const {purchaseDescription, setPurchaseDescription, language} = useContext(AppContext);
  const t = (key) => translations.Program[key]?.[language] || key;
  const translateType = (type) => { // #added traduce los tipos del backend (async/sync/pack) a algo amigable 1/8/26 TG
    const typeMap = { async: 'typeAsync', sync: 'typeSync', pack: 'typePack' };
    const key = typeMap[String(type || '').toLowerCase()];
    return key ? t(key) : type;
  };
  const [description, setDescription] = useState("");
  const {addToCart, buyNow} = useContext(AppContext); // #added el buyNow hoy 19/7/25 TG
  const [plans, setPlans] = useState([]);
  const [loadingPlans, setLoadingPlans] = useState(false);
  const [plansError, setPlansError] = useState(null);
  const route = "https://eleven.fit/timer/crossfit/"; // #added 10/7/25 TG
  const [display, setDisplay] = useState("list"); // #added 12/7/25 TG
  const [planSelected, setPlanSelected] = useState(null); // #added 12/7/25 TG
  const [selectedDetailImage, setSelectedDetailImage] = useState(null); // #added galería de imágenes del plan 1/8/26 TG

  const [tabLoading, setTabLoading] = useState(false); // #added aviso de carga al cambiar de tab 24/9/26 TG

  // #Los planes traen su traducción en la columna i18n. Aquí aplicamos
  // el idioma del sitio; los que no tengan i18n se quedan igual. TG
  const localizedPlans = useMemo(
    () => plans.map((plan) => localizePlan(plan, language)),
    [plans, language]
  );

  // #Tab 2 = Programas (sync + async), Tab 3 = Packs. #added 24/9/26 TG
  // Tab 0 = Todos: no está en el mapa, así que no filtra nada. #added 10/10/26 TG
  const TYPES_BY_TAB = { 2: ['sync', 'async'], 3: ['pack'] };

  const filteredPlans = useMemo(() => {
    const wanted = TYPES_BY_TAB[activeSection];
    if (!wanted) return localizedPlans;
    return localizedPlans.filter((plan) =>
      wanted.includes(String(plan.type || '').toLowerCase())
    );
  }, [localizedPlans, activeSection]); // eslint-disable-line react-hooks/exhaustive-deps

  // Mostramos el aviso mientras viene la red o mientras cambia el tab. TG
  const isLoadingList = loadingPlans || tabLoading;

  const changeTab = (section) => { // #added 24/9/26 TG
    if (section === activeSection) return;
    setActiveSection(section);
    setTabLoading(true);
  };

  // El filtrado es instantáneo, así que le damos un respiro para que el
  // aviso se alcance a ver; si la red sigue trabajando, esperamos. TG
  useEffect(() => {
    if (!tabLoading || loadingPlans) return;
    const tid = setTimeout(() => setTabLoading(false), 300);
    return () => clearTimeout(tid);
  }, [tabLoading, loadingPlans, activeSection]);

  // #state

  const products = [ // #products #added 25/5/25 TG
    {
      id: 1,
      name: "Xplosive Program",
      description: "Programa de Eleven Fit",
      price: 20,
      pricegtq: 150,
      main_image: "https://elevenfit.com/images/program-static-11-fit-TG.png",
    },
    {
      id: 2,
      name: "Programa de 6 meses",
      description: "Programa de 6 meses",
      price: 40,
      pricegtq: 300,
      main_image: "https://elevenfit.com/images/program-static-11-fit-TG.png"},

      {
      id: 3,
      name: "Programa de 12 meses",
      description: "Programa de 12 meses",
      price: 200,
      pricegtq: 200,
      main_image: "https://elevenfit.com/images/program-static-11-fit-TG.png",
      }
    ];

    const handleClick = (channel) => { // #added 28/3/25 TG
        // alert("Button click coming soon, thanks for clicking our button!");
        console.log("button clicked", channel);
        if (channel === "email") {
            // window.location.href = "mailto:oscar@eleven.fit";
            setPopSection(1); // que despliegue su email arriba 30/3/25 TG TG
        } else if (channel === "instagram") {
            window.location.href = "https://www.instagram.com/oscar.eleven.fit/";
        } else if (channel === "youtube") {
            window.location.href = "https://www.youtube.com/@oscarelevenfit";
        } else if (channel === "tiktok") {
            window.location.href = "https://www.tiktok.com/@oscar.eleven.fit";
        }/* else if (channel === "whatsapp") {
            window.location.href = "https://wa.me/+50256308598";
        } else if (channel === "contactForm") {
            window.location.href = "https://eleven.fit/contact";
        }*/
    };
    const [popSection, setPopSection] = useState(0);

    const contactMethods = [
        { name: "Email", icon: "📧", channel: "email" },
        { name: "Instagram", icon: "📷", channel: "instagram" },
        { name: "YouTube", icon: "▶️", channel: "youtube" },
        { name: "TikTok", icon: "🎵", channel: "tiktok" },
        //{ name: "WhatsApp", icon: "💬", channel: "whatsapp" },
        //{ name: "Contact Form", icon: "📝", channel: "contactForm" },
      ];
  const fetchPlans = async () => {
      setLoadingPlans(true);
      try {
        const response = await fetch('https://eleven.fit/php/get-plans.php', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({}) // not needed for this endpoint but React expects it
        });

        const data = await response.json();

        if (data.success) {
          setPlans(data.plans);
          console.log("#plans: ", data.plans);
        } else {
          setPlansError(data.message || 'Failed to load plans');
        }
      } catch (error) {
        console.error('Error fetching plans:', error);
        setPlansError('Network or server error');
      } finally {
        setLoadingPlans(false);
      }
    };


  useEffect(() => {
    fetchPlans();
  }, []);

  // #deep link por ID en la URL (ej: /program/3) - si viene un planId, lo seleccionamos automáticamente #added 31/7/26 TG
  useEffect(() => {
    if (!planId || plans.length === 0) return;
    const found = plans.find(p => String(p.id) === String(planId));
    if (found) {
      setDisplay("product");
      setPlanSelected(found);
      window.scrollTo(0, 0); // #added si venimos de /functional llegábamos a media página 2/10/26 TG
    } else {
      navigate("/program"); // plan no encontrado, volvemos a la lista
    }
  }, [planId, plans, navigate]);

  // #galería: al seleccionar un plan, la imagen grande empieza en la principal #added 1/8/26 TG
  useEffect(() => {
    if (planSelected) {
      setSelectedDetailImage(planSelected.main_image);
    }
  }, [planSelected]);

  // #added Meta Pixel: vio un programa. Solo cambia con el plan, no con el idioma 2/11/26 TG
  useEffect(() => {
    if (planSelected?.product_id) {
      metaEvent("ViewContent", metaProduct({ ...planSelected, id: planSelected.product_id }, language));
    }
  }, [planSelected?.product_id]);

//----------------------------
// #Clicked #Plan
//----------------------------
const clickedPlan = (plan) => { // #click #plan #select #added 12/7/25 TG
   console.log("#Clicked Plan TG: " , plan);
   setDisplay("product"); // TG
   // guardamos el plan crudo (sin traducir) para que planView pueda
   // reaplicar el idioma cuando el usuario lo cambie. #added 24/9/26 TG
   const raw = plans.find((x) => String(x.id) === String(plan.id)) || plan;
   setPlanSelected(raw);
   navigate(`/program/${plan.id}`); // #added para que la URL apunte al plan y sea compartible 31/7/26 TG
}

const goBack = () => { // #added deep link 31/7/26 TG - volver a la lista limpiando el planId de la URL
  if (planId) {
    navigate("/program");
  }
  setDisplay("list");
  setPlanSelected(null);
}
// #productize se movió a planHelpers.js para compartirlo con el link directo de compra 21/8/26 TG

// #El plan del detalle, ya con el idioma del sitio aplicado. #added 24/9/26 TG
const planView = planSelected ? localizePlan(planSelected, language) : null;

const parseMedia = (raw) => { // #added para secondary images/videos del plan (vienen como JSON string) 1/8/26 TG
  try {
    const parsed = JSON.parse(raw || '[]');
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    return [];
  }
};
const cleanPath = (p) => String(p).replace(/\\/g, '/'); // #added por si vienen paths con backslashes 1/8/26 TG

const secondaryImages = planSelected ? parseMedia(planSelected.secondary_images) : [];
const mainVideo = planView ? (planView.main_video || '') : ''; // #mod 3/10/26 TG - planView: el video del idioma del sitio, si el coach puso uno
const secondaryVideos = planSelected ? parseMedia(planSelected.secondary_videos) : [];
const detailImages = planSelected ? [planSelected.main_image, ...secondaryImages].filter(Boolean) : []; // #added galería (principal + secundarias) 1/8/26 TG


//-----------------------------
// JSX
//-----------------------------
 return (
    <div>
      <main>
        {/* Main Welcome Section */}
        <section id="program" className="section overlay tint-black-70 height-40vh">
          <div className="section__content">
            <h2 className="general-title">{t('title')}</h2>
            <h2 className="font-size-20 color-gray-3">
              {t('subtitle')}
            </h2>
          </div>
        </section>

        {display === "list" && (<section className="section-2 bg-image-floor overlay tint-black-50">



        {/* #Display #List -              GRACIAS A MI SEÑOR DIOS!!!!!!! */}
        {display === "list" && <div className="section__content program-list">{/* #mod mismo ancho que los planes 2/10/26 TG */}

          <div className="menu-wrapper program-menu margin-0-auto">{/* #mod ancho fijo para que no brinque entre tabs 2/10/26 TG */}
            
            {/* <button className={`menu-capsule ${activeSection === 1 ? "active" : ""}`} onClick={() => {setActiveSection(1)}}>{t('tabXplosive')}</button> */}
            <button className={`menu-capsule ${activeSection === 0 ? "active" : ""}`} onClick={() => changeTab(0)}>{t('tabAll')}</button>{/* #added Todos 10/10/26 TG */}
            <button className={`menu-capsule ${activeSection === 2 ? "active" : ""}`} onClick={() => changeTab(2)}>{t('tabPrograms')}</button>
            <button className={`menu-capsule ${activeSection === 3 ? "active" : ""}`} onClick={() => changeTab(3)}>{t('tabPacks')}</button>
          </div>
          <div>
      {/* <h2>{t('availablePlans')}</h2> */}{/* #deleted ya no hace falta el título 2/10/26 TG */}
      <div className="margin-top-10">{/* #added un respiro arriba del primer plan 2/10/26 TG */}
      {isLoadingList ? ( /* #added aviso de carga 24/9/26 TG */
        <div className="plans-loading">
          <span className="plans-loading__spinner" />
          <span>{t('loadingPlans')}</span>
        </div>
      ) : filteredPlans.length === 0 ? (
        <p className="plans-empty">{t('noPlans')}</p>
      ) : (
         <div className="box-container">
          {filteredPlans.map((plan, i) => (
            <div className="plan-box" key={i} onClick={()  => {clickedPlan(plan)}}>
              <div className="plan-image-container">
                {plan.main_image && (
                  <img
                    src={`${route}${plan.main_image}`}
                    alt={plan.name}
                    className="plan-image"
                  />
                )}
              </div>
              <div className="plan-info">
                <h2 className="general-h3">{plan.name}</h2>
                <div className="margin-top-20">{plan.description}</div>
                {plan.is_paid && 
                  <div>
                    ${plan.price}{plan.pricegtq ? ` | Q${plan.pricegtq}` : ''}
                  </div>
                }
                {plan.category && 
                  <div>
                    {plan.category}
                  </div>
                }
                {plan.author_email && 
                  <div>
                    {t('byLabel')} {`${plan.author_name} ${plan.author_lastname ? plan.author_lastname : ''}`}
                  </div>
                }
                {/*<div>
                  <button className="button-1">Add To Cart</button>
                  <button className="button-1">More Info</button>
                </div>*/}
              </div>
            </div>
          ))}
        </div>

      )}
      </div>
    </div>

          {activeSection === 4 && <div className="gdiv width-80 gap-10px">
                <h2 className="general-title text-align-left move-left text-shadow">
                    Free workouts
                </h2>
                <div className="general-description text-align-left move-left text-shadow margin-top-20">
                    Get our free workouts:
                <ol>
                    <li className="margin-top-40">
                    Go to our App by <a href="https://eleven.fit/timer/workouts" target="_blank" className="link">clicking here</a>.
                    <ul class="sublist">
                        <li>No installation needed.</li>
                        <li>But... you can install it if you like!</li>
                    </ul>
                    </li>
                    <li className="margin-top-40">
                    Create a user.
                    <ul class="sublist">
                        <li>Go to the top right section where it says "Register / Log In" </li>
                        <img src="./images/site/register-on-app-TG.png" alt="Register" className="img-responsive" />
                        <li className="margin-top-20">It’s <em>optional</em>, <strong>but</strong> you'll be able to save your sessions and have extra strength during your workouts.</li>
                        <li>Also, the statistics say that the fittest people do register<span class="emoji">🔥</span></li>
                    </ul>
                    </li>
                    <li className="margin-top-40">Go to Open Workout.{/*TG */}
                      <img src="./images/site/open-workout.png" alt="Open Workout" className="img-responsive margin-top-10" />
                      </li>
                    <li className="margin-top-40">Choose from All Public Workouts {/*TG  TG*/}
                    <ul class="sublist">
                        <li>Check that  the title says "All Public Workouts", if not, see the step below. </li>
                        <img src="./images/site/all-public-workouts.png" alt="Register" className="img-responsive" />
                        <li className="margin-top-20">Click Explore More Workouts. Then you will be able to browse All Public Workouts.</li>
                        <img src="./images/site/explore-more-workouts.png" alt="Register" className="img-responsive" />
                    </ul>
                    </li>
                </ol>
                </div>
                </div>}


          {/* <button className="button-2 move-left margin-top-10" onClick={() => {addToCart((totalAmount + 20), setTotalAmount, (totalAmountGTQ+150), setTotalAmountGTQ, navigate)}}> */}
          {/* #deleted botones de prueba, ya no van en la lista 2/10/26 TG
          <button className="button-2 move-left margin-top-10" onClick={() => {addToCart(products[0])}}>
                {t('addToCart')}
              </button>
          <button className="button-2 move-left margin-top-10" onClick={() => {addToCart(products[1])}}>
                {t('addToCart')} 2
              </button>
          */}
           
          </div>}
          </section>)}

          {/* #Display #Individual #product #Plan #Pack #Progam - #added 12/7/25 GRACIAS A MI SEÑOR DIOS!!!!!!!! TG TG TG TG #beautified 1/8/26 TG #clean-full-opacity 1/8/26 TG */}
            {display === "product" && planSelected && (
            <section className="section-2 overlay tint-black-50 plan-detail-section">{/* #mod misma imagen de fondo que /program, con degradado a negro 27/9/26 TG */}
              <motion.div
                key="plan-product-view"
                initial={{ opacity: 0, x: 40 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -40 }}
                transition={{ duration: 0.4 }}
                className="plan-detail-motion"
              >
                <div className="section__content">
                  <div className="plan-detail">
                    <div className="plan-detail-visual">
                      {selectedDetailImage && (
                        <div className="plan-detail-image-wrap margin-top-60">
                          <motion.img
                            key={selectedDetailImage}
                            src={`${route}${cleanPath(selectedDetailImage)}`}
                            alt={planView.name}
                            className="plan-detail-image"
                            initial={{ opacity: 0, scale: 1.03 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.35, ease: "easeOut" }}
                          />
                        </div>
                      )}
                      {detailImages.length > 0 && (
                        <div className="plan-detail-gallery">
                          {detailImages.map((img, i) => (
                            <img
                              key={i}
                              src={`${route}${cleanPath(img)}`}
                              alt={`${planView.name} ${i + 1}`}
                              className={`plan-detail-thumb ${img === selectedDetailImage ? 'selected' : ''}`}
                              onClick={() => setSelectedDetailImage(img)}
                            />
                          ))}
                        </div>
                      )}
                    </div>
                    <div className="plan-detail-info">
                        <h2 className="plan-detail-name">{planView.name}</h2>
                        {planView.category && (
                          <div className="plan-detail-category">{planView.category}</div>
                        )}
                        {planView.type && (
                          <div className="plan-detail-type">{translateType(planView.type)}</div>
                        )}
                        {planView.is_paid && (
                          <div className="plan-detail-price">
                            ${planView.price}
                            {planView.pricegtq ? ` | Q${planView.pricegtq}` : ''}
                          </div>
                        )}
                        {planView.description && (
                          <div className="plan-detail-desc">{planView.description}</div>
                        )}
                        {/* #mod videos entre la descripción corta y la larga 2/10/26 TG */}
                        {(mainVideo || secondaryVideos.length > 0) && (
                          <div className="plan-detail-videos">
                            {mainVideo && (
                              <div className="plan-detail-video">
                                <div className="responsive-player-wrapper margin-0-auto">
                                  <ReactPlayer
                                    url={mainVideo}
                                    controls
                                    width="100%"
                                    height="100%"
                                    className="react-player-2"
                                  />
                                </div>
                              </div>
                            )}
                            {secondaryVideos.map((v, i) => (
                              <div className="plan-detail-video" key={i}>
                                <div className="responsive-player-wrapper margin-0-auto">
                                  <ReactPlayer
                                    url={v}
                                    controls
                                    width="100%"
                                    height="100%"
                                    className="react-player-2"
                                  />
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                        {planView.long_description && (
                          <div
                            className="plan-detail-desc plan-detail-long"
                            dangerouslySetInnerHTML={{ __html: tidyPlanHtml(planView.long_description) }}
                          />
                        )}
                        {planView.author_name && (
                          <div className="plan-detail-author">
                            {t('byLabel')} {planView.author_name}
                            {planView.author_lastname ? ` ${planView.author_lastname}` : ''}
                          </div>
                        )}
                        <div className="plan-detail-actions">
                          <button className="button-2 move-left" onClick={() => {buyNow(productize(planView), navigate)}}>
                            {t('buyNow')}
                          </button>
                          <button className="button-2 move-left" onClick={() => {addToCart(productize(planView))}}>
                            {t('addToCart')}
                          </button>
                        </div>
                        {/* #added garantía 3/11/26 TG */}
                        <p className="font-size-14 color-gray-5 margin-top-10">
                          {t('guaranteeNote')} <a href="/refund" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "underline" }}>{t('guaranteeLink')}</a>
                        </p>
                        <button className="button-2 move-left margin-top-20" onClick={goBack}>
                          {t('goBack')}
                        </button>
                      </div>
                  </div>
                </div>
              </motion.div>

              {/* #added botones pegados abajo (comprar / carrito / volver), sobre todo pa' mobile 2/10/26 TG */}
              <div className="plan-sticky-actions">{/* #mod orden: volver, carrito, comprar 2/10/26 TG */}
                <button className="button-sticky button-sticky--ghost" onClick={goBack}>
                  {t('goBack')}
                </button>
                <button className="button-sticky" onClick={() => {addToCart(productize(planView))}}>
                  {t('addToCart')}
                </button>
                <button className="button-sticky button-sticky--primary" onClick={() => {buyNow(productize(planView), navigate)}}>
                  {t('buyNow')}
                </button>
              </div>
            </section>
            )}
      </main>
    </div>
  );
};

export default Program;